/** 登录态校验失败，只需要低授权的登录态 */
export const NOT_DEFAULT_LOGIN = 8598998000;
/** 登录态校验失败，需要高授权的登录态 */
export const NOT_SPECIAL_REGISTER = 8598999014;
/** 登录态隔离校验报错,session登录态权限不足 */
export const NO_PERMISSION = 1041330206;
/** 微信登录域名 */
export const WX_LOGIN_DOMAIN = 'wechatpay.com.hk';
